import { render, staticRenderFns } from "./Patent.vue?vue&type=template&id=e193732c&scoped=true"
import script from "./Patent.vue?vue&type=script&lang=js"
export * from "./Patent.vue?vue&type=script&lang=js"
import style0 from "./Patent.vue?vue&type=style&index=0&id=e193732c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e193732c",
  null
  
)

export default component.exports